export default "__VITE_ASSET__B7tHZ9Ak__"